import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import members from './members';
import blogs from './blogs';
import i18n from './i18n';
import global from './global';
import banner from './banner';
import coLiving from './coLiving';
import room from './room';
import apartment from './apartment';
import filter from './filter';
import modal from './modal';
import reservation from './reservation';
import booking from './booking';
import auth from './auth';
import user from './user';
import alert from './alert';
import song from './song';
import social from './social';
import community from './community';
import collect from './collect';

const reducers = combineReducers({
	routing: routerReducer,
	members,
	blogs,
	i18n,
	global,
	banner,
	coLiving,
	room,
	apartment,
	filter,
	modal,
	reservation,
	booking,
	auth,
	user,
	alert,
	song,
	social,
	community,
	collect,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js